import { render } from "./TestResultGuideForYBMClassToeicProduct.vue?vue&type=template&id=290c50c0&scoped=true"
import script from "./TestResultGuideForYBMClassToeicProduct.vue?vue&type=script&lang=js"
export * from "./TestResultGuideForYBMClassToeicProduct.vue?vue&type=script&lang=js"

import "./TestResultGuideForYBMClassToeicProduct.vue?vue&type=style&index=0&id=290c50c0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-290c50c0"]])

export default __exports__